import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';
import '../styles/PageLogin.css';
import ButtonRegular from './ui/ButtonRegular';

function PageLogin() {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [errorMessage, setErrorMessage] = useState('');
	const [notActiveEmail, setNotActiveEmail] = useState(null);
	const [infoMessage, setInfoMessage] = useState('');
	const navigate = useNavigate();
	const { login } = useContext(AuthContext);
	const token = localStorage.getItem('authToken');

	useEffect(() => {
		if (token) navigate('/');
	}, [token, navigate]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setInfoMessage('');
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/api/auth/login`,
				{ email, password }
			);

			const { token } = response.data;
			login(token);
			navigate('/profile');

} catch (error) {
	const data = error.response?.data;

	if (data?.notActive) {
		setNotActiveEmail(data.email);
		setErrorMessage(data.message);
	} else {
		setErrorMessage(data?.message || 'Wystąpił problem z logowaniem');
	}
}
	};

const handleResendActivation = async () => {
	try {
		const response = await axios.post(
			`${process.env.REACT_APP_API_URL}/api/auth/resend-activation`,
			{ email: notActiveEmail }
		);

		setInfoMessage(response.data.message);
		setErrorMessage('');
		setNotActiveEmail(null);
	} catch (err) {
		setErrorMessage(err.response?.data?.message || "Błąd wysyłania linku");
	}
};

	return (
		<div className="auth-container">
			<h1>Logowanie</h1>

			<form onSubmit={handleSubmit}>
				<div className="input-group">
					<label>Email</label>
					<input
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						placeholder="Wprowadź email"
						required
					/>
				</div>

				<div className="input-group">
					<label>Hasło</label>
					<input
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						placeholder="Wprowadź hasło"
						required
					/>
				</div>

<div className="auth-messages">
	{errorMessage && <p className="error-message">{errorMessage}</p>}

	{notActiveEmail && (
		<ButtonRegular
			type="button"
			onClick={handleResendActivation}
			className="resend-button"
		>
			Wyślij link ponownie
		</ButtonRegular>
	)}

	{infoMessage && <p className="success-message">{infoMessage}</p>}
</div>

				<ButtonRegular type="submit">
					Zaloguj się
				</ButtonRegular>
			</form>

			<div className="login-links">
				<Link to="/forgot-password" className="forgot-link">
					Zapomniałeś hasła?
				</Link>

				<p>
					Nie masz konta?{' '}
					<Link to="/register" className="switch-link">
						Zarejestruj się
					</Link>
				</p>
			</div>
		</div>
	);
}

export default PageLogin;
